export const SAVE = 'stepOtherInsuranceCoverageTugo.SAVE';
export const VALUE_CHANGED = 'stepOtherInsuranceCoverageTugo.VALUE_CHANGED';
export const LOAD = 'stepOtherInsuranceCoverageTugo.VALUE_LOAD';
export const NEXT = 'stepOtherInsuranceCoverageTugo.NEXT';
export const RESET = 'stepOtherInsuranceCoverageTugo.RESET';
export const RESET_FORM_FIELDS = 'stepOtherInsuranceCoverageTugo.RESET_FORM_FIELDS';



// WEBPACK FOOTER //
// ./app/containers/FastCover/Tugo.StepOtherInsuranceCoverage/constants.js